export const longer_8 = /^.{8,}$/;
export const shorter_64 = /^.{0,64}$/;
export const has_lowercase = /(?=.*[a-z])/;
export const has_uppercase = /(?=.*[A-Z])/;
export const has_digit = /(?=.*\d)/;
export const has_special = /(?=.*[-\/:-@\!.,+`´\-%&\(\)#$€_[-`{-~]{1,})/;
export const no_plus = /^((?!\+).)*$/;
